import {Component, EventEmitter, Input, OnChanges, OnInit, Output} from "@angular/core";
import { MathjaxModule } from "mathjax-angular";
import {FontAwesomeModule} from "@fortawesome/angular-fontawesome";
import {FormsModule} from "@angular/forms";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {
  FullProblemTemplate
} from "../../../../admin/feature/contentViewer/problemTemplatePreview/problemTemplatePreview.component";
import {checkForHTMLTags} from "../../../utils/checkForHTMLTags";
import {NgClass} from "@angular/common";

@Component({
    selector: 'multiple-choice',
  imports: [FontAwesomeModule, FormsModule, MatCheckboxModule, NgClass, MathjaxModule],
    templateUrl: './multiplechoice.component.html'
})
export class MultipleChoiceComponent implements OnInit, OnChanges {
  @Input('review') review: boolean = false;
  @Input('problem_template') problem_template!: FullProblemTemplate
  @Input('recordedAnswer') recordedAnswer: string | undefined = ''
  @Output() recordedAnswerChange = new EventEmitter<string>()
  @Output() onSelectEmitter = new EventEmitter<Function>()
  radioStyle = `accent-color: ${localStorage.getItem('primaryColor')}; margin-right: 0.5rem;`
  checkForHTMLTags = checkForHTMLTags
  showCorrectAnswers: boolean = false;

  ngOnInit() {
    this.showCorrectAnswers = this.review;
    this.hideCorrectAnswers();
  }

  ngOnChanges() {
    this.showCorrectAnswers = this.review;
    this.hideCorrectAnswers();
  }

  onSelect(answer: string) {
    if(!this.review) {
      this.recordedAnswerChange.emit(answer)
      this.onSelectEmitter.emit(this.onSelectEmitter)
    }
  }

  //there are some questions that do not have correct answers, ex: "Do you intend to study Hindi at Rutgers? - yes/no"
  //and the pte usually mark all of them as correct, so in this case we don't want to highlight all answers as correct
  hideCorrectAnswers() {
    if (this.review &&
      this.problem_template.answers.every(answer => answer.correct == 1)) {
        this.showCorrectAnswers = false;
      }
  }

}
